export const TRN_CONSTANTS = {
    maxDownloadDays: 31
}